import React from "react";
import Calendar from "@/components/Icons/content/Calendar";
import Cookie from "@/components/Icons/content/Cookie";
import BurgerMenu from "@/components/Icons/BurgerMenu";
import Close from "@/components/Icons/Close";
import ChevronDown from "@/components/Icons/ChevronDown";
import Arrow from "@/components/Icons/Arrow";
import ExclamationMark from "@/components/Icons/content/ExclamationMark";
import CakePie from "@/components/Icons/content/CakePie";
import Quote from "@/components/Icons/Quote";
import Heart from "@/components/Icons/content/Heart";
import Star from "@/components/Icons/content/Star";
import LocationPin from "@/components/Icons/content/LocationPin";
import Badge from "@/components/Icons/content/Badge";
import ChatBubbleInfo from "@/components/Icons/content/ChatBubbleInfo";
import ChatBubblesEllipsis from "@/components/Icons/content/ChatBubblesEllipsis";
import Clock from "@/components/Icons/content/Clock";
import EarthTemperature from "@/components/Icons/content/EarthTemperature";
import Hanger from "@/components/Icons/content/Hanger";
import HeartHandshake from "@/components/Icons/content/HeartHandshake";
import LightBulb from "@/components/Icons/content/LightBulb";
import Package from "@/components/Icons/content/Package";
import Rocket from "@/components/Icons/content/Rocket";
import SignPost from "@/components/Icons/content/SignPost";
import Truck from "@/components/Icons/content/Truck";
import UserCheck from "@/components/Icons/content/UserCheck";
import UserThree from "@/components/Icons/content/UserThree";
import Wallet from "@/components/Icons/content/Wallet";
import WaterDrop from "@/components/Icons/content/WaterDrop";
import Portrait from "@/components/Icons/content/Portrait";
import Interview from "@/components/Icons/content/Interview";
import DeepDive from "@/components/Icons/content/DeepDive";
import News from "@/components/Icons/content/News";
import Pressemitteilung from "@/components/Icons/content/Pressemitteilung";
import Filter from "@/components/Icons/Filter";
import Sort from "@/components/Icons/Sort";
import YouTube from "@/components/Icons/content/YouTube";
import LinkedIn from "@/components/Icons/content/LinkedIn";
import Facebook from "@/components/Icons/content/Facebook";
import Instagram from "@/components/Icons/content/Instagram";
import Mail from "@/components/Icons/content/Mail";
import WhatsApp from "@/components/Icons/content/WhatsApp";
import ShareLink from "@/components/Icons/content/ShareLink";
import Phone from "@/components/Icons/content/Phone";
import Download from "@/components/Icons/content/Download";
import Eye from "@/components/Icons/content/Eye";
import HeartFilled from "@/components/Icons/content/HeartFilled";
import Search from "@/components/Icons/Search";
import PDF from "@/components/Icons/content/PDF";
import Factory from "@/components/Icons/content/Factory";
import Dress from "@/components/Icons/content/Dress";
import HomeTextile from "@/components/Icons/content/HomeTextile";
import Shoe from "@/components/Icons/content/Shoe";

export interface IconRenderer {
    icon: string
    className?: string
    FillColor?: string
    width?: string
    height?: string
}

const IconRenderer : React.FC<IconRenderer> = ({icon,className, FillColor, width, height}) => {
    switch (icon){
        case 'icon-burger-menu':
            return <BurgerMenu className={className} FillColor={FillColor} />
        case 'icon-close':
            return <Close className={className} FillColor={FillColor} width={width} height={height} />
        case 'icon-search':
            return <Search className={className} FillColor={FillColor} />
        case 'icon-calendar':
            return <Calendar className={className} FillColor={FillColor} />
        case 'icon-cookie':
            return <Cookie className={className} FillColor={FillColor} />
        case 'icon-arrow':
            return <Arrow className={className} FillColor={FillColor} />
        case 'icon-chevron-down':
            return <ChevronDown className={className} FillColor={FillColor} />
        case 'icon-quote':
            return <Quote className={className} FillColor={FillColor} />
        case 'icon-exclamation-mark':
            return <ExclamationMark className={className} />
        case 'icon-cake-pie':
            return <CakePie className={className} />
        case 'icon-star':
            return <Star className={className} FillColor={FillColor} />
        case 'icon-heart':
            return <Heart className={className} FillColor={FillColor} />
        case 'icon-heart-filled':
            return <HeartFilled className={className} FillColor={FillColor} />
        case 'icon-heart-handshake':
            return <HeartHandshake className={className} FillColor={FillColor} />
        case 'icon-location-pin':
            return <LocationPin className={className} FillColor={FillColor} />
        case 'icon-badge':
            return <Badge className={className} FillColor={FillColor} />
        case 'icon-chat-bubble-info':
            return <ChatBubbleInfo className={className} FillColor={FillColor} />
        case 'icon-chat-bubbles-ellipsis':
            return <ChatBubblesEllipsis className={className} FillColor={FillColor} />
        case 'icon-clock':
            return <Clock className={className} FillColor={FillColor} />
        case 'icon-earth-temperature':
            return <EarthTemperature className={className} FillColor={FillColor} />
        case 'icon-hanger':
            return <Hanger className={className} FillColor={FillColor} />
        case 'icon-light-bulb':
            return <LightBulb className={className} FillColor={FillColor} />
        case 'icon-package':
            return <Package className={className} FillColor={FillColor} />
        case 'icon-rocket':
            return <Rocket className={className} FillColor={FillColor} />
        case 'icon-signpost':
            return <SignPost className={className} FillColor={FillColor} />
        case 'icon-truck':
            return <Truck className={className} FillColor={FillColor} />
        case 'icon-user-check':
            return <UserCheck className={className} FillColor={FillColor} />
        case 'icon-user-three':
            return <UserThree className={className} FillColor={FillColor} />
        case 'icon-wallet':
            return <Wallet className={className} FillColor={FillColor} />
        case 'icon-water-drop':
            return <WaterDrop className={className} FillColor={FillColor} />
        case 'icon-Interview':
            return <Interview className={className} FillColor={FillColor} />
        case 'icon-Portrait':
            return <Portrait className={className} FillColor={FillColor} />
        case 'icon-DeepDive':
            return <DeepDive className={className} FillColor={FillColor} />
        case 'icon-News':
            return <News className={className} FillColor={FillColor} />
        case 'icon-Pressemitteilung':
            return <Pressemitteilung className={className} FillColor={FillColor} />
        case 'icon-filter':
            return <Filter className={className} FillColor={FillColor} />
        case 'icon-sort':
            return <Sort className={className} FillColor={FillColor} />
        case 'icon-youtube':
            return <YouTube className={className} FillColor={FillColor} />
        case 'icon-linkedin':
            return <LinkedIn className={className} FillColor={FillColor} />
        case 'icon-facebook':
            return <Facebook className={className} FillColor={FillColor} />
        case 'icon-instagram':
            return <Instagram className={className} FillColor={FillColor} />
        case 'icon-whatsApp':
            return <WhatsApp className={className} FillColor={FillColor} />
        case 'icon-E-Mail':
            return <Mail className={className} FillColor={FillColor} />
        case 'icon-share-link':
            return <ShareLink className={className} FillColor={FillColor} />
        case 'icon-phone':
            return <Phone className={className} FillColor={FillColor} />
        case 'icon-download':
            return <Download className={className} FillColor={FillColor} />
        case 'icon-eye':
            return <Eye className={className} FillColor={FillColor} />
        case 'pdf':
            return <PDF className={className} FillColor={FillColor} />
        case 'icon-factory':
            return <Factory className={className} FillColor={FillColor} />
        case 'icon-shoe':
            return <Shoe className={className} FillColor={FillColor} />
        case 'icon-dress':
            return <Dress className={className} FillColor={FillColor} />
        case 'icon-home-textile':
            return <HomeTextile className={className} FillColor={FillColor} />
        default:
            return ''
    }
};

export default IconRenderer;